import { gql } from "@apollo/client";

export const GET_CONTACT_INFORMATION_BY_REALESTATEID = gql`
    query GetContactInformationByRealestateId($realestateid: uuid!, $consolidationid: uuid!) {
        common_realestatecontacts(where: { realestateid: { _eq: $realestateid } }) {
            facilityemail
            facilitymobile
            facilityname
            facilityphone
            manageremail
            managermobile
            managername
            managerphone
            accountantemail
            accountantmobile
            accountantname
            accountantphone
        }
        common_realestatecontacts_children: common_realestatecontacts(
            where: {
                realestate: { consolidationid: { _eq: $consolidationid } }
                _or: [
                    { facilityemail: { _neq: "" } }
                    { facilitymobile: { _neq: "" } }
                    { facilityname: { _neq: "" } }
                    { facilityphone: { _neq: "" } }
                ]
            }
            limit: 1
        ) {
            facilityemail
            facilitymobile
            facilityname
            facilityphone
        }
        house: common_houses(
            where: { realestateid: { _eq: $realestateid } }
            order_by: { housenumber: asc }
            limit: 1
        ) {
            id
        }
        coownertentant: portal_v_tenants_by_coowner_userid(where: { realestateid: { _eq: $realestateid } }, limit: 1) {
            tenantid
        }
        tentant: portal_v_tenants_by_tenant_userid(where: { realestateid: { _eq: $realestateid } }, limit: 1) {
            tenantid
        }
        coownertentantbyconsolidation: portal_v_tenants_by_coowner_userid(
            where: { consolidationid: { _eq: $consolidationid } }
        ) {
            tenantid
            tenantname
        }
        tentantbyconsolidation: portal_v_tenants_by_tenant_userid(
            where: { consolidationid: { _eq: $consolidationid } }
        ) {
            tenantid
            tenantname
        }
    }
`;
